export default __webpack_public_path__ + "static/courses-931f44d0b5c869746a4084fd82476080.jpg";